// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Sri Lanka */
const LK = /^(?:7(?:[0-25-8]\d|4[0-4])\d{6})$/;

export default LK;
